module.exports = __webpack_public_path__ + "media/images/category/feature/echigo/nagaoka-d9ed2c327eba92f6ca0b538563579da1.gif";